export default __webpack_public_path__ + "static/media/numberFour.1e74fbfb.svg";